import { baseUrl } from "../../../../boot";
import axios from "axios";

// add collection  API
export const addCoustomerAddresses = async (formData) => {
  console.log("adders form data ---- ", formData);
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}vancouverapis/webapp/customer-address/api/v1/create-Address`, formData, {
      headers: {
        "auth-token": token,
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};

// delete
export const deleteCustomerAddresses = async (id) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(`${baseUrl}vancouverapis/webapp/customer-address/api/v1/delete-address/${id}`, {
      headers: {
        "auth-token": token,
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};

// update

export const updateCustomerAddresses = async (formData) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.put(`${baseUrl}vancouverapis/webapp/customer-address/api/v1/update-address//${formData.rowId}`, formData, {
      headers: {
        "auth-token": token,
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};

// set default address
export const setDefaultAddress = async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}vancouverapis/webapp/customer-address/api/v1/set-default-address`, data, {
      headers: {
        "auth-token": token,
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};
